module.exports = __webpack_public_path__ + "img/rotateRight.bfb66dbd.png";